import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UrlContant } from 'src/app/constants/router.contant';
import { COMMON_REGEXP } from 'src/app/constants/validations';
import { AuthenticationService } from 'src/app/public-module/services/authentication.service';
import { SharedService } from 'src/app/public-module/services/shared.service';
import { ValidationsComponent } from 'src/app/shared-module/component/validations/validations.component';

@Component({
  selector: 'app-pandit-login',
  templateUrl: './pandit-login.component.html',
  styleUrls: ['./pandit-login.component.scss'],
})
export class PanditLoginComponent
  extends ValidationsComponent
  implements OnInit
{
  // Form Variables
  loginForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _sharedService: SharedService
  ) {
    super();
  }

  ngOnInit(): void {
    this.createVendorForm();
  }

  createVendorForm() {
    this.loginForm = this._fb.group({
      email: ['', [Validators.pattern(COMMON_REGEXP.EMAIL_ADDRESS_REGEXP)]],
      password: [''],
    });
  }

  onVendorLoginSubmit(form: FormGroup) {
    if (form.valid) {
      const params = form.value;
      const formData: any = new FormData();
      formData.append('email', params['email']);
      formData.append('password', params['password']);

      this._authenticationService.panditLoginPostApi(formData).subscribe(
        (res) => {
          if (res && res['role']) {
            this.loginForm.reset();
            this._sharedService.setLoginStatus(true);
            this._sharedService.setPanditDetails(res);
            this._sharedService.setLoggedInUserData(res);
            this._sharedService.setUserRole(res['role']);
            this._sharedService.setToken(res.token);
            this._sharedService.onShowMessageBar(
              'Pandit user login successfully'
            );
            if (res['role'] === 'pandit') {
              this._router.navigate(['/' + UrlContant.PANDIT_LIST]);
            } else {
              this._router.navigate(['/' + UrlContant.HOME_URL]);
            }
            const date = new Date();
            this._sharedService.setTimeStamp(date);
          } else {
            this._sharedService.onShowMessageBar(res.message);
          }
        },

        (err) => {
          this._sharedService.onShowMessageBar(err.error.message);
        }
      );
    } else {
      this._sharedService.onShowMessageBar(
        'Please enter username and password'
      );
    }
  }

  get signupUrl() {
    return '/' + UrlContant.PANDIT_SIGNUP;
  }

  get panditForgotUrl() {
    return '/' + UrlContant.PANDIT_FORGOT_EMAIL;
  }

  get formControls() {
    return this.loginForm.controls;
  }

}
